<template>
  <div class="c-app flex-row align-items-center">
    <CContainer class="col-md-7">
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <h1>Reset password</h1>
                <p class="text-muted">Set your new password</p>
                <CForm @submit.prevent="handleSubmit">
                  <CInput
                      class="mb-2"
                      placeholder="New password"
                      type="password"
                      autocomplete="password"
                      v-model="password1"
                      name="password1"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-lock-locked"/>
                    </template>
                  </CInput>
                  <CInput
                      placeholder="Repeat new password"
                      type="password"
                      autocomplete="password"
                      v-model="password2"
                      name="password2"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-lock-locked"/>
                    </template>
                  </CInput>
                  <CRow class="mt-2">
                    <CCol col="6" class="text-left">
                      <CButton color="primary" class="px-4" type="submit">
                        Change password
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    <LoginRight/>
  </div>
</template>

<script>
import { AuthService } from '@/services/auth';
import LoginRight from '@/components/LoginRight';

export default {
  name: 'ResetPassword',
  components: { LoginRight },
  data: function () {
    return {
      password1: '',
      password2: '',
    };
  },
  methods: {
    async handleSubmit() {
      if (!this.password1 || this.password1 !== this.password2) {
        return alert(this.$t('Passwords are not the same'), {
                action: {
                    text: this.$t('Close'),
                    icon: 'close',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            });
      }
      const { res } = await AuthService.resetPassword({
        password: this.password1,
        token: this.$route.params.token,
      });
      if (res.status === 200) {
        alert(this.$t('Your password has been changed. You can now login.'), {
                action: {
                    text: this.$t('Close'),
                    icon: 'close',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            });
        return this.$router.push({ name: 'ManagementLogin' });
      }
      alert(this.$t('Something went wrong'), {
                action: {
                    text: this.$t('Close'),
                    icon: 'close',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }
            });
    },
  },
};
</script>
